import { TThunkAction } from '../../types/redux';
import {
  fetchPublicMyHomeV1UpdateUserStatus,
  TPublicMyHomeV1UpdateUserStatusResponse
} from '../../repositories/price-estimator/my-home/v1/update-user-status';

import { BadRequestError } from '@cian/valuation-utils-component';
import { selectMyHomeId } from '../../selectors/page';
import { EStatus } from '../../repositories/price-estimator/entities/user_status/UpdateMyHomeStatusRequestSchema';

export function updateStatus(newStatus: EStatus): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const state = getState();
    // oxlint-disable-next-line typescript/no-non-null-assertion
    const myHomeId = selectMyHomeId(state)!;

    try {
      const resp = (await fetchPublicMyHomeV1UpdateUserStatus({
        httpApi,
        parameters: {
          myHomeId,
          status: newStatus,
        },
      })) as TPublicMyHomeV1UpdateUserStatusResponse;

      if (resp.statusCode !== 200) {
        throw new BadRequestError({
          message: resp.response.message as string,
          domain: 'updateStatus.ts',
          details: {
            errors: JSON.stringify(resp.response.errors),
          },
        });
      }
    } catch (e) {
      if (!(e instanceof BadRequestError)) {
        logger.error('Ошибка обновления статуса', {
          message: e.message,
          domain: 'updateStatus.ts',
          details: e,
        });
      } else {
        logger.debug('Ошибка обновления статуса', {
          message: e.message,
          domain: e.domain,
        });
      }
    }
  };
}
